<template>
    <div class="main-container add-ons">
        <div class="people-error" role="alert" v-if="status === 'add_on_errors'">
            <div class="alert-badge">
                <i class="far fa-exclamation-triangle"></i>
            </div>
            <div class="alert-details">
                <p class="alert-message">
                    {{ error_message }}
                </p>
            </div>
            <ul class="error-items" v-if="add_on_errors">
                <li v-for="error in add_on_errors">{{ error }}</li>
            </ul>
        </div>
        <div class="people-container p-5">
            <div class="channels">
                <h2 class="text-center font-normal">Select optional add-ons for your announcement</h2>
                <div class="channel-head">
                    <div>Inside INdiana Business</div>
                    <div class="text-center">Selection</div>
                    <div class="text-right">Pricing</div>
                </div>
                <div class="channel-options">
                    <div class="channel-option" v-if="accounts.iib.channels.newsletter.selected">
                        <div class="channel-name">
                            <img src="https://cdn.ibj.com/wp-content/uploads/2022/07/people-online.png" alt="" /> Website
                        </div>
                        <div class="text-center">Included</div>
                        <div class="text-right">$0</div>
                    </div>
                    <div class="channel-option">
                        <div class="channel-name">
                            <img src="https://cdn.ibj.com/wp-content/uploads/2022/07/people-online.png" alt="" /> Big Wigs &amp; New Gigs
                        </div>
                        <div class="text-center">
                            <v-switch v-model="accounts.iib.channels.newsletter.selected" inset hide-details></v-switch>
                        </div>
                        <div class="text-right">{{ currancy.format(accounts.iib.channels.newsletter.prices[pricing] ?? 0) }}</div>
                    </div>
                </div>
                <div class="channel-head">
                    <div>Indiana Lawyer</div>
                    <div class="text-center">Selection</div>
                    <div class="text-right">Pricing</div>
                </div>
                <div class="channel-options">
                    <div class="channel-option" v-if="accounts.il.channels.print.selected || accounts.il.channels.newsletter.selected">
                        <div class="channel-name">
                            <img src="https://cdn.ibj.com/wp-content/uploads/2022/07/people-online.png" alt="" /> Website
                        </div>
                        <div class="text-center">Included</div>
                        <div class="text-right">$0</div>
                    </div>
                    <div class="channel-option">
                        <div class="channel-name">
                            <img src="https://cdn.ibj.com/wp-content/uploads/2022/07/people-online.png" alt="" /> Print
                        </div>
                        <div class="text-center">
                            <v-switch v-model="accounts.il.channels.print.selected" inset hide-details></v-switch>
                        </div>
                        <div class="text-right">{{ currancy.format(accounts.il.channels.print.prices[pricing] ?? 0) }}</div>
                    </div>
                    <div class="channel-option">
                        <div class="channel-name">
                            <img src="https://cdn.ibj.com/wp-content/uploads/2022/07/people-online.png" alt="" /> Daily Newsletter
                        </div>
                        <div class="text-center">
                            <v-switch v-model="accounts.il.channels.newsletter.selected" inset hide-details></v-switch>
                        </div>
                        <div class="text-right">{{ currancy.format(accounts.il.channels.newsletter.prices[pricing] ?? 0) }}</div>
                    </div>
                    <div class="channel-option">
                        <div class="channel-name"></div>
                        <div class="text-right"></div>
                        <div class="text-right add-on-total">
                            <span>{{ currancy.format(add_on_total ?? 0) }}</span>
                        </div>
                    </div>
                    <div class="channel-option total-container">
                        <div class="channel-name"></div>
                        <div class="text-right"></div>
                        <div class="text-right total">
                            <span>{{ currancy.format(total ?? 0) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-between items-center">
            <button-back class="primary-outline" to="/"></button-back>
            <button class="primary" v-on:click="saveAddOns" :disabled="status === 'processing_add_ons'">
                <i class="fad fa-spinner-third fa-spin" v-if="status === 'processing_add_ons'"></i>
                {{ status === "processing_add_ons" ? "Processing" : "Continue" }}
            </button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import ButtonBack from "@/components/ButtonBack.vue";

export default {
    name: "AddOnsView",
    components: {
        ButtonBack,
    },
    props: ["account"],
    data() {
        return {
            ad_type: localStorage.getItem("people_ad_type"),
            accounts: {
                iib: {
                    channels: {
                        website: {
                            selected: false,
                            prices: {},
                        },
                        newsletter: {
                            selected: false,
                            prices: {
                                standard_feature: 0,
                            },
                        },
                    },
                },
                il: {
                    channels: {
                        website: {
                            selected: false,
                            prices: {},
                        },
                        print: {
                            selected: false,
                            prices: {
                                standard_feature: 0,
                            },
                        },
                        newsletter: {
                            selected: false,
                            prices: {
                                standard_feature: 0,
                            },
                        },
                    },
                },
            },
            current_big_wigs_price: 0,
            currancy: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }),
            status: null,
            add_on_errors: null,
            pricing: is_paid_subscriber ? "discount" : "standard",
            submission_type_name_id: {
                standard_feature: 1,
                spotlight_feature: 2,
                spotlight_feature_logo: 3,
            },
            submission_type_id_name: {
                1: "standard_feature",
                2: "spotlight_feature",
                3: "spotlight_feature_logo",
            },
            add_on_total: 0,
            total: JSON.parse(localStorage.getItem("people_order_item")).total,
            order_item: JSON.parse(localStorage.getItem("people_order_item")),
        };
    },
    watch: {
        account(newValue, oldValue) {
            this.setProducts();
            this.updatePricing();
        },
        accounts: {
            deep: true,
            handler(newValue, oldValue) {
                this.updatePricing();
                this.saveAddOnAccounts();
            },
        },
        pricing(newValue, oldValue) {
            this.updatePricing();
        },
    },
    mounted() {
        this.emitter.emit("updateProgress", { step: 2 });
        this.setProducts();
        this.updateAccounts();
        this.updatePricing();
    },
    methods: {
        updateAccounts() {
            const add_on_accounts = JSON.parse(localStorage.getItem("people_add_on_accounts")) ?? null;

            if (add_on_accounts) {
                this.accounts.iib.channels.newsletter.selected = add_on_accounts.iib?.channels?.newsletter?.selected ?? false;
                this.accounts.il.channels.print.selected = add_on_accounts.il?.channels?.print?.selected ?? false;
                this.accounts.il.channels.newsletter.selected = add_on_accounts.il?.channels?.newsletter?.selected ?? false;
            }
        },
        setProducts() {
            if (this.account) {
                this.account.addOns.accounts.forEach((account) => {
                    switch (account.label) {
                        case "iib":
                            account.products.forEach((product) => {
                                if (product.label === "big_wigs_new_gigs_" + this.ad_type) {
                                    this.accounts.iib.channels.newsletter = {
                                        id: product.id,
                                        name: product.label,
                                        selected: this.accounts.iib.channels.newsletter.selected,
                                        prices: {
                                            standard: parseInt(product.add_on_discount_amount),
                                            discount: parseInt(product.add_on_discount_amount),
                                        },
                                    };
                                }
                            });
                            break;
                        case "il":
                            account.products.forEach((product) => {
                                if (product.label === "indiana_lawyer_print_" + this.ad_type) {
                                    this.accounts.il.channels.print = {
                                        id: product.id,
                                        name: product.label,
                                        selected: this.accounts.il.channels.print.selected,
                                        prices: {
                                            standard: parseInt(product.amount),
                                            discount: parseInt(product.discount_amount),
                                        },
                                    };
                                }
                            });
                            account.products.forEach((product) => {
                                if (product.label === "indiana_lawyer_daily") {
                                    this.accounts.il.channels.newsletter = {
                                        id: product.id,
                                        name: product.label,
                                        selected: this.accounts.il.channels.newsletter.selected,
                                        prices: {
                                            standard: parseInt(product.amount),
                                            discount: parseInt(product.discount_amount),
                                        },
                                    };
                                }
                            });
                    }
                });
            }
        },
        updatePricing() {
            this.total = 0;
            this.add_on_total = 0;
            this.order_item.add_ons = { products: [] };
            this.order_item.add_ons.add_on_discount = 0;

            if (this.accounts.iib.channels.newsletter.selected) {
                this.add_on_total += parseInt(this.accounts.iib.channels.newsletter.prices[this.pricing]);
                this.order_item.add_ons.products.push(this.accounts.iib.channels.newsletter.id);
                this.order_item.add_ons.add_on_discount = 1;
            }

            if (this.accounts.il.channels.print.selected) {
                this.add_on_total += parseInt(this.accounts.il.channels.print.prices[this.pricing]);
                this.order_item.add_ons.products.push(this.accounts.il.channels.print.id);
            }

            if (this.accounts.il.channels.newsletter.selected) {
                this.add_on_total += parseInt(this.accounts.il.channels.newsletter.prices[this.pricing]);
                this.order_item.add_ons.products.push(this.accounts.il.channels.newsletter.id);
            }

            this.total = JSON.parse(localStorage.getItem("people_order_item")).total + this.add_on_total;
        },
        saveAddOnAccounts() {
            localStorage.people_add_on_accounts = JSON.stringify(this.accounts);

            this.order_item.add_ons.total = this.add_on_total;

            localStorage.people_order_item = JSON.stringify(this.order_item) ?? false;
        },
        saveAddOns() {
            this.status = "processing_add_ons";

            this.order_item.add_ons.total = this.add_on_total;

            localStorage.people_order_item = JSON.stringify(this.order_item) ?? false;

            const router = this.$router;

            router.push("/builder");
        },
    },
};
</script>

<style>
.add-on-total {
    font-weight: 700;
}

.add-on-total span::before {
    content: "Add-Ons Total:";
    position: absolute;
    left: -111px;
    color: #000000;
    white-space: nowrap;
}

.add-on-total span {
    color: #1f9d55;
    display: inline-block;
    position: relative;
}
</style>
